import { cn } from "../../lib/utils";

// Base shimmer block. `motion-safe:` gates the pulse so prefers-reduced-motion
// users get a static placeholder (no animation). Decorative → aria-hidden.
export function Skeleton({ className }) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        "motion-safe:animate-pulse rounded-md bg-slate-200/70 dark:bg-slate-700/50",
        className
      )}
    />
  );
}

// A reusable loading placeholder for a calendar/list surface: a header bar
// (title + an action), a divider, and N content rows. Wrapped in role="status"
// whose `aria-label` is the spoken announcement, while the shimmer blocks
// themselves stay aria-hidden. Renders until the first data snapshot so the
// surface never flashes its empty state mid-load (audit A-8).
export function CalendarSurfaceSkeleton({
  label = "Loading…",
  rows = 4,
  className,
}) {
  const rowCount = Number.isFinite(rows) && rows > 0 ? Math.floor(rows) : 4;
  return (
    <div
      role="status"
      aria-label={label}
      data-testid="calendar-skeleton"
      className={cn("space-y-3", className)}
    >
      <div className="flex items-center justify-between">
        <Skeleton className="h-6 w-40" />
        <Skeleton className="h-9 w-24" />
      </div>
      <Skeleton className="h-px w-full" />
      {Array.from({ length: rowCount }).map((_, i) => (
        <Skeleton key={i} className="h-16 w-full" />
      ))}
    </div>
  );
}
